class CollectionPagination {
  constructor() {
    this.initAjaxinate();
  }

  initAjaxinate() {
    if (typeof Ajaxinate !== 'undefined') {
      new Ajaxinate({
        container: '.ajaxinate-container',      // Product grid container
        pagination: '#AjaxinatePagination',    // Pagination wrapper
        method: 'scroll',                       // Or 'click'
        loadingText: 'Loading'
      });
    } else {
      console.warn('Ajaxinate is not defined.');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionPagination();
});


$(document).ready(function(){

  const $slider = $('.animated-testimonial-slider');

  function updateSliderUI(slick, currentSlide){

    let totalSlides = slick.slideCount;
    let current = currentSlide + 1;

    /* TOTAL SLIDES */
    $('.current-slide-testo').text(current);
    $('.total-slide-testo').text(totalSlides);

    /* CSS VARIABLE */
    $slider.css('--total-slides', totalSlides);

    /* PROGRESS BAR */
    let progressWidth = (current / totalSlides) * 100;

    $('.progress-bar-thumb').css('width', progressWidth + '%');

    /* PREV BUTTON HIDE */
    if(current == 1){
      $('.prev-slide-btnnn').addClass('hide-btn');
    }else{
      $('.prev-slide-btnnn').removeClass('hide-btn');
    }

    /* NEXT BUTTON HIDE */
    if(current == totalSlides){
      $('.next-slide-btnnn').addClass('hide-btn');
    }else{
      $('.next-slide-btnnn').removeClass('hide-btn');
    }

  }

  /* INIT */
  $slider.on('init', function(event, slick){

    updateSliderUI(slick, 0);

  });

  /* AFTER CHANGE */
  $slider.on('afterChange', function(event, slick, currentSlide){

    updateSliderUI(slick, currentSlide);

  });

  /* SLICK INIT */
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: false,
    speed: 900,
    cssEase: 'cubic-bezier(.77,0,.18,1)',
    adaptiveHeight: false,
    centerMode: false,
    variableWidth: false,
    responsive: [
        {
          breakpoint: 1200,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
          },
        {
          breakpoint: 767,
              settings: {
                slidesToShow: 2,
              }
          },
        {
          breakpoint: 640,
              settings: {
                slidesToShow: 1,
              }
          },
        ]
  });

  /* PREV */
  $('.prev-slide-btnnn').on('click', function(){

    $slider.slick('slickPrev');

  });

  /* NEXT */
  $('.next-slide-btnnn').on('click', function(){

    $slider.slick('slickNext');

  });

});

$(document).ready(function() {
$('.scroll-click-section').click(function(e){
    e.preventDefault();
    $('html, body').animate({
        scrollTop: $($(this).attr('href')).offset().top
    }, 800);
});

});


$(document).ready(function() {  
     $(".scroll-prompt.cat-link").click(function() {
        $('html, body').animate({
            scrollTop: $(".circle__container").offset().top - 64
        }, 1000);
    });
    $('#menu-drawer .theater__top--links .women__drawer_menu').click(function() {
      $(this).addClass('active').siblings().removeClass('active');
      $('.menu-tab-content .women-menu').addClass('active').siblings().removeClass('active');
    }); 
    $('#menu-drawer .theater__top--links .men__drawer_menu').click(function() {
      $(this).addClass('active').siblings().removeClass('active');
      $('.menu-tab-content .men-menu').addClass('active').siblings().removeClass('active');
    }); 
    const accordionJ = setInterval(function() {
      if ( $('.accordion_container .accordion_head').length){
        $(".accordion_container .accordion_body").slideUp();
        $(".accordion_container  .acc__arrow").removeClass("arrow_down");
        $('.accordion_container .accordion_head').click(function() {
          $(this).find(".acc__arrow").toggleClass("arrow_down");
          $(this).next(".accordion_body").slideToggle();
        });
        clearInterval(accordionJ);
      }
    },1000);


    $("body").on("init reInit setPosition", ".custom-dott-slide.slick-slider", function (event, slick) {
      let totalSlides = slick.slideCount;
      let slidesToShow = slick.options.slidesToShow;
      let slidesToScroll = slick.options.slidesToScroll;

      // Calculate total dots
      let totalDots = Math.ceil((totalSlides - slidesToShow) / slidesToScroll) + 1;
      if (totalDots <= 0) return;

      // Calculate dot width percentage
      let dotWidth = (100 / totalDots) + "%";

      // Apply width to dots for this specific slider only
      $(slick.$dots).find("li").css({
        "width": dotWidth,
        "flex": "0 0 " + dotWidth
      });
    });

    const $slider = $('.slider-for-lookbooks');

      $slider.on('init', function(event, slick) {
        $(this).closest('.slick-wrapper-lookbook-main').addClass('is-loaded');
      });
      // Initialize slick
      $slider.not('.slick-initialized').slick({
        dots: true,
        arrows: false,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 3000,
      });

      $("body:not(.template-page-custom-landing) .home-circle-j").slick({
        slidesToShow: 8,
        infinite:true,
        slidesToScroll: 4,
        autoplay: false,
        dots: true,
        arrows: true,
        responsive: [
        {
          breakpoint: 1420,
              settings: {
                slidesToShow: 6,
              }
          },
          {
          breakpoint: 1300,
              settings: {
                slidesToShow: 5,
              }
          },
              {
          breakpoint: 950,
              settings: {
                slidesToShow: 4,
              }
          }
        ]
      });
      $(".template-page-custom-landing .home-circle-j").slick({
        slidesToShow: 9,
        infinite:true,
        slidesToScroll: 4,
        autoplay: false,
        dots: true,
        arrows: false,
        responsive: [
          {
            breakpoint: 1420,
                settings: {
                  slidesToShow: 6,
                }
            },
            {
            breakpoint: 1300,
                settings: {
                  slidesToShow: 5,
                }
            },
                {
            breakpoint: 950,
                settings: {
                  slidesToShow: 4,
                }
            }
        ]
      });
      $(".featured-brand-slider").slick({
          infinite: true,
          slidesToShow:5,
          slidesToScroll:1,
          dots:false,
          arrows:false,
          autoplay: true,
          responsive: [{
          breakpoint: 1199,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 991,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1
              }
          },
          {
            breakpoint: 767,
              settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
              }
          }]
      });
      $(".circle__container .home-circle-custom-j").slick({
        slidesToShow: 8,
        infinite:true,
        slidesToScroll: 4,
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 1420,
                settings: {
                  slidesToShow: 6,
                }
            },
            {
            breakpoint: 1300,
                settings: {
                  slidesToShow: 5,
                }
            },
                {
            breakpoint: 950,
                settings: {
                    arrows: false,
                    infinite: false,
                    slidesToShow: 4.4,
                    slidesToScroll: 1
                  }
            }
          ]
      });
      $('.a-plus-pro-grid').on('init', function(event, slick) {
          if (slick.slideCount <= 1) {
              $(this).addClass('single-slide-a-plus');
          }
      });
      $('.a-plus-pro-grid').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          centerMode: true,
          infinite: true,
          arrows: true,
          dots: false,
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 990,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1
              }
            }
          ]
      }); 
      $(".lookbook-slider-with-hotspots .slider-hotspots-inner").slick({
        slidesToShow: 4,
        infinite:true,
        slidesToScroll: 4,
        autoplay: true,
        dots: false,
        arrows: false,
        responsive: [
            {
            breakpoint: 1300,
                settings: {
                  slidesToShow: 3,
                }
            },
                {
            breakpoint: 950,
                settings: {
                  slidesToShow: 1,
                }
            }
        ]
      });
      $(".slider-row-cstm-kai").slick({
        slidesToShow: 3.5,
        infinite: false,
        slidesToScroll: 1,
        autoplay: false,
        dots: false,
        arrows: true,
        prevArrow: '<div class="previous-button-slide-cstm arrow-btn-cstm-main"><svg width="4" height="7" viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.04819 6.09705L-0.000312492 3.04855L3.04819 5.40614e-05L3.65919 0.598054L1.17619 3.04855L3.65919 5.49905L3.04819 6.09705Z" fill="#1A1815"/></svg></div>',
        nextArrow: '<div class="nect-button-slide-cstm arrow-btn-cstm-main"><svg width="4" height="7" viewBox="0 0 4 7" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.603735 6.09705L-0.000765577 5.49905L2.47573 3.04855L-0.000765577 0.598054L0.603735 5.40614e-05L3.65873 3.04855L0.603735 6.09705Z" fill="#1A1815"/></svg></div>',
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 2.5,
            }
          },
          {
            breakpoint: 950,
            settings: {
              slidesToShow: 1.5,
            }
          },
          {
            breakpoint: 565,
            settings: {
              slidesToShow: 1.3,
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1.1,
            }
          }
        ]
      }); 
      $(".product-media-modal .product-media-modal__content .zoom-slider-wrapper").slick({
        slidesToShow: 1,
        infinite:true,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        asNavFor: '.product-media-modal .product-media-modal__content .thumbnails-wrapper',
      }); 
      $(".product-media-modal .product-media-modal__content .thumbnails-wrapper").slick({
        slidesToShow: 5,
        infinite:true,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        asNavFor: '.product-media-modal .product-media-modal__content .zoom-slider-wrapper',
        focusOnSelect: true,
        responsive: [
            {
              breakpoint: 1420,
                  settings: {
                    slidesToShow: 5,
                  }
              },
              {
              breakpoint: 950,
                  settings: {
                      arrows: false,
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
              }
            ]
      }); 
      $('.circle_categories_w_filter .circle__filter_a').click(function(e){
          if($(this).hasClass('other_circle_target')){
            var get_tag = $(this).data('tag');
            $('.circle_displayed_products .grid-display__item').removeClass('active');
              $('.circle_displayed_products .grid-display__item.target_' + get_tag).addClass('active');
          }else{
            $('.circle_displayed_products .grid-display__item').addClass('active');
          }
              $('.circle__filter_inner_div').removeClass('active_cat');
            $(this).parent().find('.circle__filter_inner_div').addClass('active_cat');
      }); 
      $(".homebook-slider2 .home_lookbook-carousel:not(.trackScrolling)").slick({
        focusOnSelect: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        dots:false,
        autoplay: false,
        speed: 500,
        arrows:true,
        infinite: true,
        prevArrow: '<div class="prev-btn arrow-btn"><svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.1" d="M23.6667 33.3333L20.6979 30.4167L32.3646 18.75H0V14.5833H32.3646L20.6979 2.91667L23.6667 0L40.3333 16.6667L23.6667 33.3333Z" fill="black"/></svg></div>',
        nextArrow: '<div class="next-btn arrow-btn"><svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.1" d="M23.6667 33.3333L20.6979 30.4167L32.3646 18.75H0V14.5833H32.3646L20.6979 2.91667L23.6667 0L40.3333 16.6667L23.6667 33.3333Z" fill="black"/></svg></div>',
        responsive: [
            {
            breakpoint: 1440,
                settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
            }
          },
          {
          breakpoint: 1199,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                dots:false,
                arrows:false,
                infinite: true,
            }
        },
        {
          breakpoint: 767,
          settings: "unslick"
        }]
      });
      const $sliderpdp = $(".slick-slider-js-pdp");

      $sliderpdp.on("init reInit afterChange", function(event, slick, currentSlide) {
        const i = (currentSlide ? currentSlide : 0) + 1;

        $(".current-slide_cstm").text(i);
        $(".total-slides_cstm").text(slick.slideCount);
      });

      $sliderpdp.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        autoplay: false,
        speed: 500,
        arrows: true,
        infinite: false,
        prevArrow: '<div class="prev-btn arrow-btn"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.74228e-07 10C1.10609e-06 7.34783 1.05357 4.80429 2.92893 2.92893C4.8043 1.05357 7.34784 -1.10609e-06 10 -8.74228e-07C11.3132 -7.59423e-07 12.6136 0.258657 13.8268 0.761203C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C18.9464 4.8043 20 7.34784 20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C8.68678 20 7.38642 19.7413 6.17317 19.2388C4.95991 18.7362 3.85752 17.9997 2.92893 17.0711C2.00035 16.1425 1.26375 15.0401 0.761204 13.8268C0.258658 12.6136 7.59423e-07 11.3132 8.74228e-07 10ZM12 4L6 10L12 16L13.4 14.6L8.8 10L13.4 5.4L12 4Z" fill="white"/></svg></div>',
        nextArrow: '<div class="next-btn arrow-btn"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 10C20 12.6522 18.9464 15.1957 17.0711 17.0711C15.1957 18.9464 12.6522 20 10 20C8.68678 20 7.38642 19.7413 6.17317 19.2388C4.95991 18.7362 3.85752 17.9997 2.92893 17.0711C1.05357 15.1957 0 12.6522 0 10C0 7.34784 1.05357 4.8043 2.92893 2.92893C4.8043 1.05357 7.34784 0 10 0C11.3132 0 12.6136 0.258658 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.7413 7.38642 20 8.68678 20 10ZM8 16L14 10L8 4L6.6 5.4L11.2 10L6.6 14.6L8 16Z" fill="white"/></svg></div>',
      });
      $(".lookbook-slider-c ").slick({
        slidesToShow: 1,
        infinite:true,
        slidesToScroll: 1,
        autoplay: true,
        dots: true,
        arrows: false
      }); 

      const productCount = $('.similar_products_grid .grid-display__item').length;
      if(productCount > 4){
        $('.similar_products_grid').slick({
          slidesToShow: 4,
          slidesToScroll: 1,
          dots:false,
          autoplay: false,
          speed: 500,
          arrows:true,
          infinite: true,
          prevArrow: '<div class="prev-btn arrow-btn"><svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.1" d="M23.6667 33.3333L20.6979 30.4167L32.3646 18.75H0V14.5833H32.3646L20.6979 2.91667L23.6667 0L40.3333 16.6667L23.6667 33.3333Z" fill="black"/></svg></div>',
          nextArrow: '<div class="next-btn arrow-btn"><svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.1" d="M23.6667 33.3333L20.6979 30.4167L32.3646 18.75H0V14.5833H32.3646L20.6979 2.91667L23.6667 0L40.3333 16.6667L23.6667 33.3333Z" fill="black"/></svg></div>',
          responsive: [
            
            {
            breakpoint: 1199,
              settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  dots:false,
                  infinite: true,
              }
          },
          {
            breakpoint: 767,
            settings: "unslick"
                // settings: {
                //    slidesToShow: 2.5,
                //    slidesToScroll: 2,
                //    dots:false,
                //    arrows:false,
                //    infinite: true,
                //   centerPadding: '12px',
                // }
          }]
        });
      }

        // Open
      $('body').on('click', '.product__info-wrapper .size_guide_texture.above__addtocart .size_guide_popup', function() {
        $(' .product__info-wrapper .popup_size_guide').show();
        $('body').addClass('open__sizeguide');
      });
      // Close
      $('body').on('click', ' .product__info-wrapper .size_guide_close', function() {
        $('.popup_size_guide').hide();
        $('body').removeClass('open__sizeguide');
      });
      $('body').on('click', ' .size_guide_shoes .size_guide_shoes_link', function() {
        $(this).next().addClass("active");
      });
      $('body').on('click', '.size_guide_shoes .shoes-size-chart-popup .header-top-wrap .close-wrap', function() {
        $(this).parents(".shoes-size-chart-popup").removeClass("active");
      });
      $('.product_color__links.product-form__option-swatches-wrapper.metafield_swatch').each(function() {
        if (!$(this).html().trim()) {
          $(this).hide();
        }
      });
        if($(window).width() > 768) {
            const slider = document.querySelector('.home_lookbook-carousel:not(.trackScrolling)');
            let isDown = false;
            let startX;
            let scrollLeft;
          
            slider.addEventListener('mousedown', (e) => {
              isDown = true;
              slider.classList.add('active');
              startX = e.pageX - slider.offsetLeft;
              scrollLeft = slider.scrollLeft;
              // console.log("erreerre", scrollLeft)
            });
          
            slider.addEventListener('mouseleave', () => {
              isDown = false;
              slider.classList.remove('active');
            });
          
            slider.addEventListener('mouseup', () => {
              isDown = false;
              slider.classList.remove('active');
            });
          
            slider.addEventListener('mousemove', (e) => {
              if (!isDown) return;  // stop the fn from running
              e.preventDefault();
              const x = e.pageX - slider.offsetLeft;
              const walk = (x - startX) * 2;
              slider.scrollLeft = scrollLeft - walk;
              
              // console.log('sdsd', scrollLeft)
              // console.log(slider.scrollLeft)
            });
        
        
            //   touchEvents
        
            slider.addEventListener('touchstart', (e) => {
              isDown = true;
              slider.classList.add('active');
              startX = e.pageX - slider.offsetLeft;
              scrollLeft = slider.scrollLeft;
            });
          
            slider.addEventListener('touchend', () => {
              isDown = false;
              slider.classList.remove('active');
            });
          
            slider.addEventListener('touchcancel', () => {
              isDown = false;
              slider.classList.remove('active');
            });
          
            slider.addEventListener('touchmove', (e) => {
              if (!isDown) return;  // stop the fn from running
              e.preventDefault();
              const x = e.pageX - slider.offsetLeft;
              const walk = (x - startX) * 2;
              slider.scrollLeft = scrollLeft - walk;
            });
        }
        if ($(window).width() < 768) {
          $('.custom-image-video-wrap:not(.trending)  .home_lookbook-carousel:not(.trackScrolling)').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots:true,
                autoplay:true,
                infinite: true, 
          });
        }
        $('.home_lookbook-carousel .slick-slide video').trigger('pause');
        $('.home_lookbook-carousel .slick-slide.slick-active video').trigger('play');
        $('.home_lookbook-carousel').on('afterChange', function(event, slick, currentSlide, nextSlide){
        $('.home_lookbook-carousel .slick-slide video').trigger('pause');
        $('.home_lookbook-carousel .slick-slide.slick-active video').trigger('play');
        });
        if($(window).width() < 768) {
          $('.footer .footer__content-top .footer-block__heading').click(function() {
              $(this).toggleClass("active");
              $(this).siblings(".footer-block__details-content").toggle();
          }); 
        }
      
        $(".featured-home-slider").on('init', function(event, slick) {
          $(this).append('<div class="slick-counter"><span class="current"></span> / <span class="total"></span></div>');
          $('.current').text(slick.currentSlide + 1);
          $('.total').text(slick.slideCount);
          }).slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            dots:false,
            autoplay: false,
            speed: 500,
            arrows:false,
            infinite: true,
            responsive: [
              {
              breakpoint: 1199,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    dots:false,
                    infinite: true
                }
            },
              {
              breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    dots:false,
                    infinite: true
                }
            },
            {
              breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots:false,
                    infinite: true
                }
            }]
          })
          .on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                $('.current').text(nextSlide + 1);
        });
        $(".lookbook-slider-with-hotspots .shoppable-item__hotspot-position").click(function() {
          $(this).parent().toggleClass("active");
        });
      }); 
      function isMobileDevice() {
          return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      }
      if (isMobileDevice()) {

          if (window.location.href.includes('products')) {
            /* document.querySelectorAll('.product__modal-opener').forEach(element => {
                element.style.pointerEvents = 'none';
              }); */
              let scale = 1;
              let lastScale = 1;
              let initialDistance = 0;

              const zoomableImages = document.querySelectorAll('.product__media .image-magnify-lightbox');
            
              zoomableImages.forEach(image => {
                  image.scale = 1;
                  image.lastScale = 1;
                  // console.log(image);
                  image.addEventListener('click', function(event) {
                  // console.log("Clicked");
                      event.preventDefault(); 
                  });
                  image.addEventListener('touchstart', handleTouchStart);
                  image.addEventListener('touchmove', handleTouchMove);
                  image.addEventListener('touchend', handleTouchEnd);
              });

              function handleTouchStart(event) {
              
                  if (event.touches.length > 1) {
                      const image = event.target;
                      initialDistance = getDistance(event.touches);
                      image.lastScale = image.scale; 
                  }
              }

              function handleTouchMove(event) {
                  // Allow scrolling with one finger and prevent default only for pinch zoom
                  if (event.touches.length > 1) {
                      event.preventDefault(); // Prevent scrolling for pinch zoom
                      const image = event.target;
                      const currentDistance = getDistance(event.touches);
                      image.scale = image.lastScale * (currentDistance / initialDistance);
                      image.style.transform = `scale(${image.scale})`;
                  }
              }

              function handleTouchEnd(event) {
                  // If all touches are lifted, reset the zoom to normal
                  if (event.touches.length === 0) {
                      const image = event.target;
                      image.style.transition = 'transform 0.2s'; // Smooth transition back to original scale
                      image.style.transform = `scale(1)`; // Reset zoom to original scale
                      image.scale = 1; // Reset scale variable
                      image.lastScale = 1; // Reset lastScale variable
                  }
              }

              function getDistance(touches) {
                  const dx = touches[0].pageX - touches[1].pageX;
                  const dy = touches[0].pageY - touches[1].pageY;
                  return Math.sqrt(dx * dx + dy * dy);
              }
          }
      }
      /*================ start newsletter popup =========*/
      var get_storage_popup = localStorage.getItem("Newsletter-popup");
      var window_path = window.location.href;
      
      if(get_storage_popup == null){
      
        if(window_path.includes('#newsletterPopupForm')){
            if(window_path.includes('?customer_posted=true')){
              setTimeout(function(){
                $('.newsletter_popup').addClass('visible');
            },2000);
            }else{
              setTimeout(function(){
                $('.newsletter_popup').addClass('visible');
              },10000);
            }
        }
        else{
          setTimeout(function(){
                $('.newsletter_popup').addClass('visible');
              },10000);
        }
      } 
  
    $('.newsletter_popup .popup__close').click(function(){
      localStorage.setItem("Newsletter-popup", "true");
      $(this).parents('.newsletter_popup').removeClass('visible');
    });
    /* THTR-DEV-APR-364 Newsletter Popup */
    $('.copy-trigger').on('click', function(){
      var code = $('#couponCode').text();
      navigator.clipboard.writeText(code).then(function() {
        const icon = $('.copy-icon svg');
        const originalIcon = icon.html();

        // Swap to checkmark SVG
        icon.replaceWith(`
          <svg class="copied-check" xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#1E1D66" viewBox="0 0 24 24">
            <path d="M20.285 6.709l-11.285 11.291-5.285-5.291 1.414-1.414 3.871 3.877 9.871-9.877z"/>
          </svg>
        `);

        setTimeout(() => {
          $('.copied-check').replaceWith(`
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="#1E1D66" viewBox="0 0 24 24">
              <path d="M16 1H4a2 2 0 0 0-2 2v14h2V3h12V1z"/>
              <path d="M20 5H8a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm0 18H8V7h12v16z"/>
            </svg>
          `);
        }, 1500);
      });
    });
    /*  Newsletter Popup */  
    /*============= end newsletter popup =============*/

    /* For open OTP login Popup */
    $(".login-popup-link").click(function() {
        localStorage.setItem("lastest_refer",window.location.href);
        $(".login-popup").addClass("active");
        $(".overlay-login-popup").addClass("active");
       return false;
      });
       $(".login-popup .close-btn").click(function() {
        $(".login-popup").removeClass("active");
        $(".overlay-login-popup").removeClass("active");
    });
    /* End For open OTP login Popup */
    // Play video on click
    document.addEventListener("DOMContentLoaded", function () {
        const playButtons = document.querySelectorAll(".play-video");
        playButtons.forEach(function (button) {
          button.addEventListener("click", function () {
            const parent = button.closest(".slider-inner");
            const video = parent.querySelector("video");

            if (video) {
              video.setAttribute("autoplay", true);
              video.setAttribute("muted", true); // Optional: Needed for autoplay to work in some browsers
              video.play();
              button.style.display = "none"; // Hide play button after playing
            }
          });
        });
    });
    // Play video on click

    // For select Size
    let attempts = 0;
    const maxAttempts = 5; // will check for 30 seconds (50 * 600ms)
    const intervalIdJ = setInterval(function () {
      attempts++;
      const now = new Date().toLocaleTimeString();
      const notifyButton = document.getElementById('peppy-notify-me-button-container');
      if (notifyButton) {
        notifyButton.style.display = 'none';
        //clearInterval(intervalId);
      }

      if (attempts >= maxAttempts) {
        clearInterval(intervalIdJ);
      }
    },400);
    $(document).on('click', '.chip-wrapper input[type="radio"]', function () {
      var $productOverlayBtn = $('.addtocart__btn__overlay');
      if ($productOverlayBtn.length) {
        $productOverlayBtn.removeClass('selectsize_show');
      }
      setTimeout(() => {
            const $addToCartBtn = $('.product-form__submit.button');
            if (!$addToCartBtn.length) return;
          
            const isDisabled = $addToCartBtn.is(':disabled');
          
            const $buyBtn = $('.template-product .shopify-payment-button');
            const $notifyButton = $('.notify_me_btn');
            if (!isDisabled) {
              $buyBtn.show();
              $notifyButton.hide();
            } else {
              $buyBtn.hide();
              $notifyButton.show();
            }
        }, 1000);
    });

    // End
    // custom Menu drawer js

    $(document).ready(function() {
      $('header-drawer #menu-drawer .back-close-wrap .close-wrap').click(function() {
        $('.menu-drawer-container').removeClass("menu-opening");
        $('.menu-drawer-container').removeAttr('open');
        $('.header__icon--menu').attr('aria-expanded', 'false');
        $('.section-header').removeClass("menu-open");
        $('body').removeClass("overflow-hidden-desktop");
      });
      $('body').on('click', '.size_guide_shoes .switch', function () {
        $(this).toggleClass("active");
        const isActive = $(this).hasClass("active");

        // remove active from both first
        $(".size_guide_shoes .size-chart-shapewear .table").removeClass("active");
        $(".size_guide_shoes .size-toggle span").removeClass("active");

        if (isActive) {
          // when switch has active
          $(".size_guide_shoes .size-toggle span.on-label").addClass("active");
          $(".size_guide_shoes .size-chart-shapewear .table.in-inches").addClass("active");
        } else {
          // when switch does NOT have active
          $(".size_guide_shoes .size-toggle span.off-label").addClass("active");
          $(".size_guide_shoes .size-chart-shapewear .table.in-cm").addClass("active");
        }
      });
    });
    if ($('header-drawer #menu-drawer .submenu-open').length) {
      $('header-drawer #menu-drawer .back-close-wrap').addClass('active');
    } else {
      $('header-drawer #menu-drawer .back-close-wrap').removeClass('active');
    }

    $(document).on('click', '.sticky_product_bar .sticky__btns button', function () {
      if ($('body').hasClass('template-product-shapewear') || $('body').hasClass('template-product-winter_fur-withsizechart')) {
        $('html, body').animate({
          scrollTop: $('.product__info-wrapper').offset().top
        }, 600); // adjust duration if needed
      }
    });

    document.addEventListener("DOMContentLoaded", function () {
      const sections = document.querySelectorAll("section");
      sections.forEach((section) => {
        const loader = section.querySelector(".loader-skelton-style");
        const rebuyBox = section.querySelector(".rebuy-widgets-main");

        if (!loader || !rebuyBox) return;

        // Start loader visible
        loader.style.display = "flex";
        const observer = new MutationObserver(() => {
          if (rebuyBox.innerHTML.trim() !== "") {
            loader.style.display = "none";
            observer.disconnect();
          }
        });

        observer.observe(rebuyBox, { childList: true, subtree: true });
      });
    });

    document.addEventListener("click", function(e) {
      // OPEN MODAL
      const openButton = e.target.closest("[data-open-modal]");

      if (openButton) {
        const id = openButton.getAttribute("data-open-modal");
        const modal = document.querySelector(`[data-modal-id="${id}"]`);

        if (!modal) return;

        modal.classList.add("active");
        document.body.classList.add("modal-open");

        setTimeout(function() {
          const $slider = $(modal).find(".slick-slider-js-pdp");

          if ($slider.length && $slider.hasClass("slick-initialized")) {
            $slider.slick("setPosition");
          }
        }, 200);

        return;
      }

      // CLOSE MODAL
      const closeButton = e.target.closest(
        ".universal-modal__close, .universal-modal__overlay"
      );

      if (closeButton) {
        const modal = closeButton.closest(".universal-modal");

        if (!modal) return;

        modal.classList.remove("active");
        document.body.classList.remove("modal-open");
      }
    });
      // PROMO MODAL – OPEN ONLY ONCE PER SESSION
    const promoModalShown = sessionStorage.getItem("promoModalShown");
    // Open modal
    function openUniversalModal(id) {
      const modal = document.querySelector(`[data-modal-id="${id}"]`);
      if (modal) {
        modal.classList.add("active");
        document.body.classList.add("modal-open");
      }
    }
    // Close modal
    function closeUniversalModal(id) {
      const modal = document.querySelector(`[data-modal-id="${id}"]`);
      if (modal) {
        modal.classList.remove("active");
        document.body.classList.remove("modal-open");
      }
    }
    // Close modal on clicking close button
    document.addEventListener("click", (e) => {
      // If user clicks the button OR the SVG inside the button
      if (
        e.target.classList.contains("universal-modal__close") ||
        e.target.closest(".universal-modal__close")
      ) {
        const modal = e.target.closest("[data-modal-id]");
        if (modal) {
          closeUniversalModal(modal.getAttribute("data-modal-id"));
        }
      }
    });

 //=================== Start This Code for Cart Nudge JS  ====================

    function hasModalShown() {
      const lastShown = localStorage.getItem("cartModalShownAt");

      if (!lastShown) return false;

      const hours24 = 24 * 60 * 60 * 1000;

      return (Date.now() - Number(lastShown)) < hours24;
    }

        // ===== User presence tracking (sabhi tabs ke liye common) =====
        const AWAY_LIMIT = 30 * 60 * 1000;   // 30 minute door rehna zaroori
        const HEARTBEAT_MS = 5000;      // har 5 sec "last seen" update
        let pendingReminder = false;

        function isUserOnPage() {
          return document.visibilityState === "visible" && document.hasFocus();
        }

        function touchLastSeen() {
          localStorage.setItem("siteLastSeenAt", Date.now());
        }

        function wasUserAway() {
          const lastSeen = Number(localStorage.getItem("siteLastSeenAt") || 0);
          return lastSeen > 0 && (Date.now() - lastSeen) >= AWAY_LIMIT;
        }

        // Page load par check karo (heartbeat shuru hone se pehle)
        pendingReminder = wasUserAway();
        touchLastSeen();

        // Jab tak user site par hai, last seen update hota rahe
        setInterval(() => {
          if (isUserOnPage()) touchLastSeen();
        }, HEARTBEAT_MS);

        // Tab/window chhodte waqt last time save karo
        window.addEventListener("blur", touchLastSeen);
        window.addEventListener("pagehide", touchLastSeen);
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "hidden") touchLastSeen();
        });

        // User wapas aaya: agar 1 min+ door tha to popup check karo
        function onUserReturn() {
          if (!isUserOnPage()) return;
          const away = wasUserAway();
          touchLastSeen();
          if (away) {
            pendingReminder = true;
            loadCartItems(true);
            pendingReminder = false;
          }
        }
        window.addEventListener("focus", onUserReturn);
        document.addEventListener("visibilitychange", onUserReturn);

        // Cart empty ho gaya to 24h wala lock reset, taaki naya product add hone par process dobara chale
        function markCartActivity() {
          const cart = window.Rebuy?.Cart?.getCart();
          if (cart && cart.items && cart.items.length === 0) {
            localStorage.removeItem("cartModalShownAt");
          }
        }

    // function markCartActivity() {
    //   const cart = window.Rebuy?.Cart?.getCart();

    //   if (cart && cart.items && cart.items.length > 0) {
    //     if (!localStorage.getItem("cartLastActiveAt")) {
    //       localStorage.setItem("cartLastActiveAt", Date.now());
    //     }
    //   }
    // }

    // function shouldShowCartReminder() {
    //   const lastActive = localStorage.getItem("cartLastActiveAt");

    //   if (!lastActive) return false;

    //   const timePassed = Date.now() - Number(lastActive);

    //   // 30 minutes
    //   const thirtyMinutes = 1 * 60 * 1000;

    //   return timePassed >= thirtyMinutes;
    // }

    function updateCheckoutTotal() {

      const parentBtn = document.querySelector(".checkout-button-main");

      if (parentBtn) parentBtn.classList.add("loadingMain");

      const cart = window.Rebuy?.Cart?.getCart();

      if (!cart) {
        if (parentBtn) parentBtn.classList.remove("loadingMain");
        return;
      }

      let totalProductSaving = 0;
      let totalMrp = 0;

      cart.items.forEach(item => {

        const quantity = item.quantity || 1;

        const unitDiscounted = (item.discounted_price ?? item.price) / 100;

        const unitOriginal = (item.final_price ?? item.price ) / 100;

        totalMrp += unitOriginal * quantity;

        const itemSaving =
          (unitOriginal - unitDiscounted) * quantity;

        if (itemSaving > 0) {
          totalProductSaving += itemSaving;
        }
        
      });

      // Total Amount
      const totalAmountRaw = cart.total_price / 100;

      const totalAmount =
        totalMrp < 3500
          ? (totalAmountRaw * 0.90).toFixed(2) // 10% off
          : totalAmountRaw.toFixed(2);

      document
        .querySelectorAll(".total-payment-amount")
        .forEach(el => {
          el.textContent = `Rs. ${totalAmount}`;
        });
        

      // Saving
      // let finalSaving = totalProductSaving;
      let finalSaving = 0;

      if (totalMrp < 3500) {
        // Static 10%
        finalSaving = totalAmountRaw * 0.10;

      } else {
        // Actual Shopify/Rebuy discount
        cart.items.forEach(item => {
          item.discounts?.forEach(discount => {
            finalSaving += (discount.amount || 0) / 100;
          });
        });

      }


      if (totalMrp < 3500) {
        document.querySelectorAll(".hide-for-above-10").forEach(el => {
          el.classList.remove("hide-for-above-10");
        });
        startCountdown(10);
      }

      document
      .querySelectorAll(".total-saving-amount")
      .forEach(el => {
        el.textContent = `Rs. ${finalSaving.toFixed(2)}`;
      });

      // MRP
      document
        .querySelectorAll(".totalMrpAmnt")
        .forEach(el => {
          el.textContent = `Rs. ${totalMrp.toFixed(2)}`;
        });

      // Coupon + Timer
      const timerWrap = document.querySelector(".countdown-wrapper");
      const couponWrap = document.querySelector(".coupon-wrapper");

      if (totalMrp < 3500) {

        if (timerWrap) timerWrap.style.display = "block";
        if (couponWrap) couponWrap.style.display = "block";

      } else {

        if (timerWrap) timerWrap.style.display = "none";
        if (couponWrap) couponWrap.style.display = "none";

        clearInterval(countdownInterval);
      }

      if (parentBtn) {
        parentBtn.classList.remove("loadingMain");
      }
    }

    // -------------------------------
    // LIVE UPDATE: whenever Rebuy cart changes
    // -------------------------------
    document.addEventListener("rebuy:cart.change", () => {
      updateCheckoutTotal();
      markCartActivity();
    });

    // Function: Fetch cart items from Rebuy
    function loadCartItems(showOnLoad = true) {

      // Get Rebuy cart data
      const cart = window.Rebuy?.Cart?.getCart();
      if (!cart || cart.items.length === 0) {
        return;
      }

      // 24 hours check
      if (showOnLoad && hasModalShown()) {
        return;
      }
      if (showOnLoad && !pendingReminder) {
        return;
      }
      
          // Fill cart items
          let container = document.getElementById("cartItemsContainer");
            let html = "";
            cart.items.forEach(item => {

              const quantity = item.quantity || 1;

              const unitDiscounted = (item.final_price) / 100;

              const unitOriginal =
                item.product?.selected_variant?.compare_at_price ||
                (item.original_price ?? item.compare_at_price ?? item.price) / 100;

                const discountedd = (unitDiscounted * quantity).toFixed(2);

                const original = (unitOriginal * quantity).toFixed(2);

                const hasDiscount = Number(original) > Number(discountedd);

                const image =
                  item.image_url ||
                  item.image ||
                  item.product_image;

                html += `
                  <div class="cart-item" data-key="${item.key}">
                    <div class="cart-item-image-innr">
                      <img src="${image}" alt="">
                    </div>

                    <div class="cardContentInner">
                      <h2>${item.product_title}</h2>

                      <div class="quantity_price_product">
                        QTY: ${quantity}
                      </div>

                      <div class="price-style-list-main">
                        <span class="mrpPriceCstm">MRP</span>

                        ${
                          hasDiscount
                            ? `
                              <span class="discountPriceCstm">RS. ${discountedd}</span>
                              <span class="regularPriceCstm">RS. ${original}</span>
                            `
                            : `
                              <span class="discountPriceCstm">RS. ${discountedd}</span>
                            `
                        }
                      </div>
                    </div>
                  </div>
                `;
            });

          container.innerHTML = html;
      


      // UPDATE full cart total from Rebuy
      updateCheckoutTotal();

      // Show reminder modal
      showCartModal();
    }

    document.addEventListener("rebuy:cart.ready", () => {
      setTimeout(() => {
        loadCartItems(true);
        pendingReminder = false;
      }, 2000);
    });

    let countdownInterval;

    function startCountdown(minutes = 10) {

      let timeLeft = minutes * 60;

      const timerWrap = document.querySelector(".countdown-wrapper");
      const timerEl = document.querySelector(".countdown-time");

      timerWrap.style.display = "block";

      clearInterval(countdownInterval);

      countdownInterval = setInterval(() => {

        const mins = Math.floor(timeLeft / 60);
        const secs = timeLeft % 60;

        timerEl.textContent =
          `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;

        if (timeLeft <= 0) {
          clearInterval(countdownInterval);
          timerWrap.style.display = "none"; // auto hide
          return;
        }

        timeLeft--;

      }, 1000);
    }

    function showCartModal() {
      document.getElementById("cartReminderModal").style.display = "flex";
      const scrollY = window.scrollY;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
      startCountdown(10);
      localStorage.setItem("cartModalShownAt", Date.now());
    }

    // document.getElementById("closeCartModal").addEventListener("click", function () {
    //   localStorage.setItem("cartModalShownAt", Date.now());
    //   const top = document.body.style.top;
    //   document.body.style.position = "";
    //   document.body.style.top = "";
    //   window.scrollTo(0, parseInt(top || "0") * -1);
    //   document.getElementById("cartReminderModal").style.display = "none";
    // });
    const closeCartModalBtn = document.getElementById("closeCartModal");

    if (closeCartModalBtn) {
      closeCartModalBtn.addEventListener("click", function () {

        localStorage.setItem("cartModalShownAt", Date.now());

        const top = document.body.style.top;

        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.right = "";
        document.body.style.width = "";

        window.scrollTo(0, parseInt(top || "0", 10) * -1);

        const cartModal = document.getElementById("cartReminderModal");

        if (cartModal) {
          cartModal.style.display = "none";
        }
      });
    }


    // Show modal only once per session + only if cart has products
    window.addEventListener("DOMContentLoaded", () => {
      loadCartItems(true);
    });



    let copyTimer;

    const copyBtnCntnt = document.getElementById("copyBtnCntnt");

      if (copyBtnCntnt) {

        copyBtnCntnt.addEventListener("click", function () {

          const input = document.getElementById("couponCodeDataCopy");

          if (!input) return;

          const value = input.value;
          const btn = this;

          navigator.clipboard.writeText(value).then(() => {

            btn.classList.add("copied");

            clearTimeout(copyTimer);

            copyTimer = setTimeout(() => {
              btn.classList.remove("copied");
            }, 1000);

          });

        });

      }

    


    const modalCheckoutBtn = document.getElementById("modalCheckoutBtn");

    if (modalCheckoutBtn) {

      modalCheckoutBtn.addEventListener("click", function (e) {

        e.preventDefault();

        const drawerCheckoutBtn = document.querySelector(
          '[onclick="onCheckoutClick(this)"]'
        );

        if (drawerCheckoutBtn && typeof onCheckoutClick === "function") {
          onCheckoutClick(drawerCheckoutBtn);
        }

      });

    }

    // =================== End This Code for Cart Nudge JS  ====================

    document.addEventListener("DOMContentLoaded", function () {

      function updateRebuySplideDots() {
        const dotsUl = document.querySelector(".rebuy-product-grid ul");

        if (!dotsUl) return false;

        const dots = dotsUl.querySelectorAll("li");
        if (dots.length === 0) return false;

        const dotWidth = (100 / dots.length) + "%";

        dots.forEach((dot) => {
          dot.style.width = dotWidth;
          dot.style.flex = "0 0 " + dotWidth;
        });

        return true;
      }

      // --- 1️⃣ Retry System (Ensures slider loads first) ---
      let tries = 0;
      let maxTries = 20; // tries for ~4 seconds

      function retryDots() {
        if (updateRebuySplideDots()) {
          return; // success
        }
        tries++;
        if (tries < maxTries) {
          setTimeout(retryDots, 200);
        }
      }
      retryDots();
      // --- 2️⃣ MutationObserver (Detect when Rebuy injects slider) ---
      const observer = new MutationObserver(() => {
        updateRebuySplideDots();
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
      // --- 3️⃣ Rebuy JS Event Listener (if Rebuy fires events) ---
      document.addEventListener("rebuy:cart.show", updateRebuySplideDots);
      document.addEventListener("rebuy:cart.ready", updateRebuySplideDots);
      document.addEventListener("rebuy:page.load", updateRebuySplideDots);
      document.addEventListener("rebuy:products.loaded", updateRebuySplideDots);
    });


window.addEventListener("load", () => {

  document.querySelectorAll(".slider-wrapper-scrolling").forEach(slider => {

    const viewport = slider.querySelector(".viewportScrolling");
    const scrollbar = slider.querySelector(".scrollbar");
    const thumb = slider.querySelector(".thumbScrolling");

    let dragging = false;

    function hasOverflow() {
      return viewport.scrollWidth > viewport.clientWidth;
    }

    // function updateUI() {
    //   if (!hasOverflow()) {
    //     scrollbar.style.display = "none";
    //     viewport.scrollLeft = 0;
    //     return;
    //   }
    //   scrollbar.style.display = "block";
    //   syncThumb();
    // }
    function updateUI() {
      const noOverflow = !hasOverflow();

      // scrollbar show/hide
      scrollbar.style.display = noOverflow ? "none" : "block";

      // scroll reset if no overflow
      if (noOverflow) {
        viewport.scrollLeft = 0;
      }

      // ✅ class toggle on slider-wrapper-scrolling
      slider.classList.toggle("tiles-section-center", noOverflow);

      if (!noOverflow) {
        syncThumb();
      }
    }

    function syncThumb() {
      if (!hasOverflow()) return;

      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      const maxThumb = scrollbar.clientWidth - thumb.clientWidth;

      thumb.style.left =
        (viewport.scrollLeft / maxScroll) * maxThumb + "px";
    }

    /* ----- DRAG ----- */
    thumb.addEventListener("pointerdown", e => {
      dragging = true;
      thumb.setPointerCapture(e.pointerId);
    });

    ["pointerup", "pointercancel", "pointerleave"].forEach(evt => {
      thumb.addEventListener(evt, () => dragging = false);
    });

    thumb.addEventListener("pointermove", e => {
      if (!dragging || !hasOverflow()) return;

      const rect = scrollbar.getBoundingClientRect();
      let x = e.clientX - rect.left - thumb.clientWidth / 2;

      const maxThumb = scrollbar.clientWidth - thumb.clientWidth;
      x = Math.max(0, Math.min(x, maxThumb));

      thumb.style.left = x + "px";

      const maxScroll = viewport.scrollWidth - viewport.clientWidth;
      viewport.scrollLeft = (x / maxThumb) * maxScroll;
    });

    viewport.addEventListener("scroll", syncThumb);
    window.addEventListener("resize", updateUI);

    updateUI(); // INIT
  });

});

(function () {
  document.addEventListener('click', function (e) {
    const cartClick = e.target.closest(
      'a[href="/cart"], a[href^="/cart?"], button[name="cart"], .header__icon--cart'
    );

    if (!cartClick) return;

    e.preventDefault();
    e.stopPropagation();

    if (window.Rebuy && Rebuy.Cart && Rebuy.Cart.show) {
      Rebuy.Cart.show();
    }
  });
})();



(function () {

  const RP_MODAL = '.rp-modal-wrap';
  const RP_TRIGGER = '.rp-trigger-link';
  const RP_CLOSE = '.rp-close-btn';

  let rpScrollY = 0;
  let rpBodyLocked = false;

  function openRPModal(trigger) {
    if (!trigger) return;

    const modal = document.querySelector(RP_MODAL);


    if (!modal) return;

    // Already open
    if (modal.style.display === 'block') return;

    // Store current scroll position
    rpScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

    // Show modal
    modal.style.display = 'block';

    // Lock body
    if (!rpBodyLocked) {
      document.body.dataset.rpBodyPosition =
        document.body.style.position || '';

      document.body.dataset.rpBodyTop =
        document.body.style.top || '';

      document.body.dataset.rpBodyLeft =
        document.body.style.left || '';

      document.body.dataset.rpBodyRight =
        document.body.style.right || '';

      document.body.dataset.rpBodyWidth =
        document.body.style.width || '';

      document.body.style.position = 'fixed';
      document.body.style.top = `-${rpScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';

      document.body.classList.add('rp-modal-open');

      rpBodyLocked = true;
    }
  }

  function closeRPModal(modal) {
    if (!modal) return;

    modal.style.display = 'none';

    if (rpBodyLocked) {

      document.body.style.position =
        document.body.dataset.rpBodyPosition || '';

      document.body.style.top =
        document.body.dataset.rpBodyTop || '';

      document.body.style.left =
        document.body.dataset.rpBodyLeft || '';

      document.body.style.right =
        document.body.dataset.rpBodyRight || '';

      document.body.style.width =
        document.body.dataset.rpBodyWidth || '';

      document.body.classList.remove('rp-modal-open');

      delete document.body.dataset.rpBodyPosition;
      delete document.body.dataset.rpBodyTop;
      delete document.body.dataset.rpBodyLeft;
      delete document.body.dataset.rpBodyRight;
      delete document.body.dataset.rpBodyWidth;

      rpBodyLocked = false;

      window.scrollTo(0, rpScrollY);
    }
  }

  document.addEventListener('click', function (event) {

    // OPEN
    const trigger = event.target.closest(RP_TRIGGER);

    if (trigger) {
      event.preventDefault();

      openRPModal(trigger);

      return;
    }

    // CLOSE BUTTON
    const closeButton = event.target.closest(RP_CLOSE);

    if (closeButton) {
      const modal = closeButton.closest(RP_MODAL);

      if (modal) {
        event.preventDefault();
        closeRPModal(modal);
      }

      return;
    }

    // OUTSIDE CLICK
    if (event.target.matches(RP_MODAL)) {
      closeRPModal(event.target);
    }

  });

})();

document.querySelector('.open-toggle-accord')?.addEventListener('click', function (e) {
  e.preventDefault();

  const head = document.querySelector('#sizeBlockAccord .accordion_head');

  head?.classList.add('arrow_down');

  const arrow = head?.querySelector('.acc__arrow');
  arrow?.classList.add('arrow_down');

  const body = head?.nextElementSibling;

  body?.style.setProperty('display', 'block', 'important');
});



// // Modal Open for return&Exchange Modal
// const rpLink = document.querySelector(".rp-trigger-link");
// const rpModal = document.querySelector(".rp-modal-wrap");
// const rpClose = document.querySelector(".rp-close-btn");

// let scrollY = 0;

// // OPEN
// rpLink.addEventListener("click", function(e) {
//   e.preventDefault();
//   openModal();
// });

// // CLOSE BUTTON
// rpClose.addEventListener("click", closeModal);

// // OUTSIDE CLICK
// window.addEventListener("click", function(e) {
//   if (e.target === rpModal) {
//     closeModal();
//   }
// });

// // 🔥 FUNCTIONS
// function openModal() {
//   scrollY = window.scrollY;

//   rpModal.style.display = "block";

//   document.body.classList.add("rp-modal-open");
//   document.body.style.position = "fixed";
//   document.body.style.top = `-${scrollY}px`;
//   document.body.style.left = "0";
//   document.body.style.right = "0";
//   document.body.style.width = "100%";
// }

// function closeModal() {
//   rpModal.style.display = "none";

//   document.body.classList.remove("rp-modal-open");
//   document.body.style.position = "";
//   document.body.style.top = "";
//   document.body.style.left = "";
//   document.body.style.right = "";
//   document.body.style.width = "";

//   window.scrollTo(0, scrollY);
// }


